import React from 'react';
import PropTypes from 'prop-types';
import { DatePickerStyled } from '@nike/nike-design-system-components';

const DatePicker = ({ name, label, value, onChange, style, error, errorMessage, min, max, ...props }) => {
  const formattedValue = value ? value.split('T')[0] : '';

  return (
    <DatePickerStyled
      style={style}
      name={name}
      id={name}
      label={label}
      value={formattedValue}
      error={error}
      readOnly={false}
      errorMessage={errorMessage}
      autoComplete='off'
      min={min}
      max={max}
      onChange={onChange}
      locale='US'
      iconTitle='Calendar Icon'
      {...props}
    />
  );
};

DatePicker.defaultProps = {
  value: null,
  onChange: null,
  style: null,
  error: false,
  errorMessage: '',
  min: new Date().toISOString().split('T')[0],
  max: null
};

DatePicker.propTypes = {
  style: PropTypes.object,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  min: PropTypes.string,
  max: PropTypes.string
};

export default DatePicker;
